export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11129.e5e38b39.jpg";